import { Link, useLocation } from 'react-router-dom';

/*
 * Navigation de l'espace invité.
 * Styles : mc-guest.css. Dans la barre du bas mobile (.mc-guest-bottombar),
 * le même composant passe automatiquement en horizontal via le CSS.
 */
function GuestNavlist() {
  const { pathname } = useLocation();

  const links = [
    {
      href: '/guest/listing/reservations',
      label: 'Réservations',
      icon: 'bi-calendar-check',
    },
    {
      href: '/guest/listing/reviews',
      label: 'Avis invités',
      icon: 'bi-star',
    },
    {
      href: '/guest/favorites',
      label: 'Mes favoris',
      icon: 'bi-heart',
    },
    {
      href: '/guest/settings',
      label: 'Paramètres invité',
      icon: 'bi-gear',
    },
  ];

  return (
    <nav className="mc-guest-nav" aria-label="Espace invité">
      {links.map(({ href, label, icon }) => {
        const isActive = pathname === href || pathname.startsWith(href + '/');

        return (
          <Link
            key={href}
            to={href}
            className={`mc-guest-nav-item${isActive ? ' is-active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
          >
            <span className="mc-guest-nav-icon" aria-hidden="true">
              <i className={`bi ${icon}`}></i>
            </span>

            <span className="mc-guest-nav-label">{label}</span>

            <i className="bi bi-chevron-right mc-guest-nav-arrow" aria-hidden="true"></i>
          </Link>
        );
      })}
    </nav>
  );
}

export default GuestNavlist;
